@if (canInstall) {
<app-button
    [color]="'accent'"
    [icon]="'install_mobile'"
    [buttonType]="'mat-fab extended'"
    [ariaLabel]="'Install FLOWDOX.AI'"
    [text]="'Install FLOWDOX'"
    (click)="installPwa()"
></app-button>
}